var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserPhoneSettingsPage',_vm._b({key:_vm.phoneRouteKey},'UserPhoneSettingsPage',_vm.config,false))}
var staticRenderFns = []

export { render, staticRenderFns }